import React from 'react';
import tick from '../../../../../../../assets/images/tick.svg';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/stake/stake-success.module.scss';
import Header from '../../../../../../../components/Stake/header';
import OmIcon from '../../../../../../../assets/images/tokens/om.svg';

const MigrateFinish = () => (
  <>
    <Header icon={OmIcon} title='OM-Migration' />
    <div className={stylesParent.cardContent}>
      <div className={styles.icon}>
        <img src={tick} alt='' />
      </div>
      <div className={styles.status}>Migration Completed</div>
    </div>
  </>
);

export default MigrateFinish;
